import { render, staticRenderFns } from "./filesDosage.vue?vue&type=template&id=2958e45c&scoped=true&"
import script from "./filesDosage.vue?vue&type=script&lang=js&"
export * from "./filesDosage.vue?vue&type=script&lang=js&"
import style0 from "./filesDosage.vue?vue&type=style&index=0&id=2958e45c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2958e45c",
  null
  
)

export default component.exports